import { Box, Typography, Link, Button } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { openWhatsApp } from "./contact_sources";
import { useNavigate, useLocation } from "react-router-dom";
export default function NavBar() {
  //SCROLL FUNCTION

  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMenuPage = location.pathname === "/menu";
  const menuLinkColour = "white";
  const customBlack = "#252525ff";
  const navRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuOpen &&
        navRef.current &&
        !navRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [mobileMenuOpen]);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }

    const section = document.getElementById(id);
    if (section) {
      const yOffset = -80;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Box
      ref={navRef}
      sx={{
        position: "fixed",
        zIndex: 1200,
        display: "flex",
        width: "100%",

        justifyContent: "space-between",
        height: {
          xs: mobileMenuOpen ? "260px" : scrolled ? "80px" : "100px",
          md: scrolled ? "80px" : "100px",
        },
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "flex-start", md: "center" },
        backgroundColor: {
          xs: mobileMenuOpen || scrolled ? "#ffffff" : "transparent",
          md: scrolled || isMenuPage ? "#ffffff" : "transparent",
        },

        // ✨ animations
        transition:
          "height 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease, opacity 0.3s ease",

        transform: scrolled ? "translateY(0)" : "translateY(0)",

        opacity: scrolled ? 1 : 0.95,

        boxShadow: scrolled ? "0 4px 10px rgba(0,0,0,0.25)" : "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          flexDirection={"row"}
          sx={{ display: "flex", alignItems: "flex-end" }}
        >
          <Box
            component="img"
            src="/logo_hr_transparent.png"
            alt="Caramel Cottage Logo"
            sx={{
              height: 60,
              width: "auto",
              objectFit: "contain",
            }}
          />
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "#e99e26ff" }}
          >
            COTTAGE
          </Typography>
        </Box>

        <Box sx={{ display: "flex" }}>
          <Box sx={{ display: { xs: "none", md: "flex" }, mr: 4 }}>
            <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("home");
                }}
                underline="none"
                sx={{
                  position: "relative",
                  color: scrolled || isMenuPage ? customBlack : menuLinkColour,
                  fontSize: "18px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -2,
                    width: "0%",
                    height: "2px",
                    bgcolor: "#cf9237",
                    transition: "0.3s ease",
                  },
                  "&:hover": {
                    color: "#cf9237",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                Home
              </Link>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/menu");
                }}
                href="#"
                underline="none"
                sx={{
                  position: "relative",
                  color: scrolled || isMenuPage ? customBlack : menuLinkColour,
                  fontSize: "18px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -2,
                    width: "0%",
                    height: "2px",
                    bgcolor: "#cf9237",
                    transition: "0.3s ease",
                  },
                  "&:hover": {
                    color: "#cf9237",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                Menu
              </Link>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("about");
                }}
                href="#"
                underline="none"
                sx={{
                  position: "relative",
                  color: scrolled || isMenuPage ? customBlack : menuLinkColour,
                  fontSize: "18px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -2,
                    width: "0%",
                    height: "2px",
                    bgcolor: "#cf9237",
                    transition: "0.3s ease",
                  },
                  "&:hover": {
                    color: "#cf9237",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                About
              </Link>

              <Link
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("contact");
                }}
                href="#"
                underline="none"
                sx={{
                  mr: 2,
                  position: "relative",
                  color: scrolled || isMenuPage ? customBlack : menuLinkColour,
                  fontSize: "18px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -2,
                    width: "0%",
                    height: "2px",
                    bgcolor: "#cf9237",
                    transition: "0.3s ease",
                  },
                  "&:hover": {
                    color: "#cf9237",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                Contact
              </Link>
            </Box>
            <Button
              onClick={() => openWhatsApp()}
              sx={{
                background: "linear-gradient(45deg, #f29c24, #d56d12)",
                borderRadius: "12px",
                px: 1.875,
                py: 1.075,
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                "&:hover": {
                  transform: "scale(1.02)", // enlarge
                  boxShadow: "0 2px 15px rgba(0,0,0,0.25)",
                  background: "linear-gradient(45deg,#d9a14a, #c28729)",
                },
              }}
            >
              Order Now
            </Button>
          </Box>

          <Button
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            sx={{
              display: { xs: "block", md: "none" },
              background: "linear-gradient(45deg, #d9a14a, #c28729)",
              borderRadius: "12px",
              color: "white",
              fontWeight: "bold",
              textTransform: "none",
              mr: 2,
              mt: 2,
            }}
          >
            Menu
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: { xs: mobileMenuOpen ? "flex" : "none", md: "none" },
          flexDirection: "column",
          width: "100%",
          px: 3,
          pt: 2,
          gap: 2,
          animation: mobileMenuOpen ? "slideDown 0.3s ease" : "none",
        }}
      >
        {[
          { label: "Home", id: "home" },
          { label: "Menu", route: "/menu" },
          { label: "About", id: "about" },
          { label: "Contact", id: "contact" },
        ].map((item) => (
          <Link
            key={item.id}
            underline="none"
            onClick={() => {
              if (item.route) {
                navigate(item.route); 
              } else {
                scrollToSection(item.id);
              }
              setMobileMenuOpen(false);
            }}
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              color: "#252525ff",
            }}
          >
            {item.label}
          </Link>
        ))}
      </Box>
    </Box>
  );
}
